// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2oYpr","title":"AfterBackImages_title__djhHE","images":"AfterBackImages_images__2T0eK"};